import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueTheMask from 'vue-the-mask'
import VueRouter from 'vue-router'
import router from './router.js'
import store from './stores'
import i18n from './i18n'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'es6-promise/auto' //for vuex
import VueBrowserUpdate from 'vue-browserupdate'
import browserDetect from "vue-browser-detect-plugin"

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueTheMask)
Vue.use(VueRouter)
Vue.use(browserDetect)
Vue.use(VueBrowserUpdate, {
  options: {
    required: {
      e: -1,
      f: -1,
      c: -1,
      s: -1,
      o: -1
    },
    text: "Seu navegador está desatualizado. Por favor, atualize para uma melhor experiência.",
    l: "pt",
    noclose:true,
  },
});


Vue.config.productionTip = false
Vue.config.devtools = true

let vueInstance = new Vue({
  render: h => h(App),
  router,
  store,
  i18n
})

vueInstance.$mount('#app')

export default vueInstance

